import { TokenPairFeesResponse } from '@/pages/api/tokens/fees';
import useSWR from 'swr';
import { Address } from 'viem';

import { ClientNetworkError } from '@/lib/errors/client';

import { routes } from '@/utils/routes';
import { objectToQueryString } from '@/utils/string';

const fetcher = async (url: string) => {
  const res = await fetch(url);

  if (!res.ok) {
    const message = await res.text();
    throw new ClientNetworkError(message);
  }
  return res.json();
};

export function useTokenFeeConfig(
  params: {
    tokenAddressA: Address | undefined;
    tokenAddressB: Address | undefined;
    chainIdA: number | undefined;
    chainIdB: number | undefined;
  },
  options: { shouldFetch: boolean } = { shouldFetch: true },
) {
  const requiredParams = Object.values(params).every(Boolean);
  const queryString = objectToQueryString(params);
  const url =
    options.shouldFetch && requiredParams ? `${routes.api.TOKEN_FEE_CONFIG}${queryString}` : null;

  return useSWR<TokenPairFeesResponse | undefined, Error>(url, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
  });
}
